﻿var moment = require('moment');

module.exports = [formatting];

function formatting() {
    var service = {
        cleanGoodsCode: cleanGoodsCode,
        flattenArray: flattenArray,
        formatDate: formatDate,
        formatDateFromNow: formatDateFromNow,
        goodsCodeToGoodsnomId: goodsCodeToGoodsnomId,
        isChapterCode: isChapterCode,
        isCommodityCode: isCommodityCode,
        isHeadingCode: isHeadingCode,
        isNullOrEmpty: isNullOrEmpty,
        padLeft: padLeft,
        padRight: padRight,
        removeTrailingZeros: removeTrailingZeros,
        replaceAll: replaceAll,
        numberToRoman: numberToRoman,
        romanToNumber: romanToNumber,
        toChapterNumber: toChapterNumber
    };

    return service;

    function cleanGoodsCode(goodsCode) {
        if (!goodsCode) return null;
        return replaceAll(goodsCode, '[\\s.,]', '');
    }

    function flattenArray(item, elemName) {
        var output = [];

        if (item[elemName] !== null && item[elemName] !== undefined && item[elemName].length > 0) {
            for (var i = 0; i < item[elemName].length; i++) {
                output.push(item[elemName][i]);
                var subItems = flattenArray(item[elemName][i], elemName);
                output = output.concat(subItems);
            }
        }
        return output;
    }

    function formatDate(date) {
        return moment(date).format('DD-MM-YYYY HH:mm');
    }

    function formatDateFromNow(date, useAgo) {
        if (useAgo === undefined || useAgo === null)
            useAgo = false;
        return moment(date).fromNow(useAgo);
    }

    function goodsCodeToGoodsnomId(goodsCode) {
        if (!goodsCode) return null;
        return padRight(replaceAll(goodsCode, '[\\s.,]', ''), 10);
    }

    function isChapterCode(code) {
        if (!code) return false;
        var goodsnomid = goodsCodeToGoodsnomId(code);
        return /[0-9]{10}/.test(goodsnomid) && goodsnomid.substring(2) === '00000000';
    }

    function isHeadingCode(code) {
        if (!code) return false;
        var goodsnomid = goodsCodeToGoodsnomId(code);
        return /[0-9]{10}/.test(goodsnomid) && goodsnomid.substring(2) !== '00000000' && goodsnomid.substring(4) === '000000';
    }

    function isCommodityCode(code) {
        if (!code) return false;
        var goodsnomid = goodsCodeToGoodsnomId(code);
        return /[0-9]{10}/.test(goodsnomid);
    }

    function isNullOrEmpty(source) {
        return (source === undefined ||
            source === null ||
            source === '');
    }

    function padLeft(n, width, z) {
        if (!n) return null;
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    function padRight(n, width, z) {
        if (!n) return null;
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : n + new Array(width - n.length + 1).join(z);
    }

    function removeTrailingZeros(goodsCode) {
        if (!goodsCode) return null;
        var result = goodsCode.replace(/0+$/, '');
        return result.length % 2 === 0 ? result : result + '0';
    }

    function replaceAll(str, search, replacement) {
        return str.replace(new RegExp(search, 'g'), replacement);
    }

    function numberToRoman(num) {
        const romanNumerals = [
            { value: 1000, numeral: 'M' },
            { value: 900, numeral: 'CM' },
            { value: 500, numeral: 'D' },
            { value: 400, numeral: 'CD' },
            { value: 100, numeral: 'C' },
            { value: 90, numeral: 'XC' },
            { value: 50, numeral: 'L' },
            { value: 40, numeral: 'XL' },
            { value: 10, numeral: 'X' },
            { value: 9, numeral: 'IX' },
            { value: 5, numeral: 'V' },
            { value: 4, numeral: 'IV' },
            { value: 1, numeral: 'I' }
        ];

        let result = '';
        for (let i = 0; i < romanNumerals.length; i++) {
            while (num >= romanNumerals[i].value) {
                result += romanNumerals[i].numeral;
                num -= romanNumerals[i].value;
            }
        }
        return result;
    }

    function romanToNumber(roman) {
        roman = roman.toUpperCase();
        const romanNumerals = {
            'I': 1,
            'V': 5,
            'X': 10,
            'L': 50,
            'C': 100,
            'D': 500,
            'M': 1000
        };

        let total = 0;
        for (let i = 0; i < roman.length; i++) {
            const currentVal = romanNumerals[roman[i]];
            const nextVal = romanNumerals[roman[i + 1]];

            if (nextVal && currentVal < nextVal) {
                total -= currentVal;
            } else {
                total += currentVal;
            }
        }
        return total;
    }

    function toChapterNumber(code) {
        if (!code) return null;
        if (code.substring(0, 1) === '0') {
            return code.substring(1, 2);
        }
        return code.substring(0, 2);
    }
}
